/* Reposition the app's original node: its handlers and dialog remain app-owned. */
(() => {
  const controllers = new WeakMap();

  function init(root) {
    if (controllers.has(root)) return;
    let share = null;

    function positionShare() {
      const slot = root.querySelector('[data-cart-share-slot]');
      if (!slot) return;
      const entries = [...root.querySelectorAll('.mmc-share-cart__wrap')];
      // Prefer a freshly injected app node if the app rebuilt its entry.
      const replacement = entries.find((entry) => entry !== share && !slot.contains(entry));
      if (replacement) {
        if (share && share !== replacement) share.remove();
        share = replacement;
      } else if (!share) {
        share = entries[0];
      }
      if (!share) return;
      entries.forEach((entry) => {
        if (entry !== share) entry.remove();
      });
      // CartForm replaces page-heading.innerHTML during AJAX merges. Keeping
      // this reference restores the same node, including its original events.
      if (share.parentElement !== slot) slot.append(share);
      const link = share.querySelector('a[href="#share-link"]');
      if (link && link.textContent !== 'Share cart') link.textContent = 'Share cart';
    }

    const observer = new MutationObserver(positionShare);
    observer.observe(root, { childList: true, subtree: true });
    controllers.set(root, observer);
    positionShare();
  }

  function initAll() {
    document.querySelectorAll('cart-form[data-cart-share-heading]').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
